module.exports = __webpack_public_path__ + "static/img/untreated.9411b2c3.png";